export default __webpack_public_path__ + "static/special-afe8907fda95f3d39bb6de328e986563.png";